<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  mounted() {
    if (
      "/" == this.$route.path ||
      "/mobile/index" == this.$route.path ||
      "/pc/index" == this.$route.path
    ) {
      if (this._isMobile()) {
        this.logJs.report("/mobile/index");
        this.$router.replace("/mobile/index");
      } else {
        this.logJs.report("/pc/index");
        this.$router.replace("/pc/index");
      }
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style lang="less">
@import "~src/styles/Normalize";
@import "~src/styles/index";

body {
  background-color: #1c1b20;
}
</style>
